<template>
    <to-cart-btn
        :product-id="actualItem.ID"
        :is-loading="isLoading"
        :in-cart="!!productInCart"
        class="equipment-card__to-cart"
        @click.prevent="addToCart"
    ></to-cart-btn>
</template>

<script>
import { EVENT_ADD_TO_CART } from '../../services/event-bus/event-types';
import { globalErrorHandler } from '../../services/error-handling';

const { eventBus } = window.specialtyApp;

export default {
    name: 'equipment-card-controls',

    inject: ['$basketService'],

    data() {
        return {
            isLoading: false,
        };
    },

    props: {
        actualItem: {
            type: Object,
            required: true,
        },

        purchaseAllowed: {
            type: Boolean,
            required: true,
        },

        detailUrl: {
            type: String,
        },

        deliveryPeriods: {
            type: Object,
        },
    },

    computed: {
        basketRows() {
            return Object.values(this.$basketService.state.basketData.BASKET.ITEMS);
        },

        productInCart() {
            return this.basketRows.find((basketItem) => `${basketItem.PRODUCT_ID}` === `${this.actualItem.ID}`);
        },
    },

    methods: {
        async addToCart() {
            if (this.purchaseAllowed) {
                this.isLoading = true;

                try {
                    const { data: { data } } = await this.$basketService.addToBasket(
                        this.actualItem.ID,
                        1,
                    );
                    eventBus.$emit(EVENT_ADD_TO_CART, {
                        basketData: data,
                        quantity: 1,
                        type: 'equipment',
                        actualItem: this.actualItem,
                        deliveryPeriods: this.deliveryPeriods,
                    });
                    this.inCart = true;
                } catch (error) {
                    globalErrorHandler(error);
                } finally {
                    this.isLoading = false;
                }
            } else {
                $('#notify_url').val(this.detailUrl);
                $('#notifyAvailable').modal('show');
            }
        },
    },

    watch: {
        productInCart: {
            immediate: true,
            deep: true,
            handler(newProduct) {
                this.productChangeProcess = true;

                if (newProduct) {
                    this.quantity = newProduct.QUANTITY;
                } else {
                    this.quantity = 1;
                }

                this.$nextTick(() => {
                    this.productChangeProcess = false;
                });
            },
        },
    },
};
</script>
